class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  handleContact = () => {
    const message = this.createChatBotMessage(
      `Visit our Contact Page: (https://${window.location.hostname}/contact)`
    );
    this.updateChatbotState(message);
  };

  handleTrackOrder = () => {
    const message = this.createChatBotMessage(
      "Please enter your mobile number:",
      {
        widget: "trackOrder",
      }
    );
    this.updateChatbotState(message);
  };

  handleTrackLink = () => {
    const trackingUrl = `https://${window.location.hostname}/order-tracking`;
    const message = this.createChatBotMessage(
      "You can track your order here:",
      {
        widget: "trackOrderLink",
        payload: trackingUrl,
      }
    );
    this.updateChatbotState(message);
  };

  updateChatbotState(message) {
    this.setState((prev) => ({
      ...prev,
      messages: [...prev.messages, message],
    }));
  }
}

export default ActionProvider;
